import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import Products from '../Products/Products';
import { SEOHead, LocalBusinessSchema, BreadcrumbSchema, ServiceSchema } from '../SEO';

const ProductsPage: React.FC = () => {
  const breadcrumbs = BreadcrumbSchema([
    { name: "Home", url: "/" },
    { name: "Products", url: "/products" }
  ]);

  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [LocalBusinessSchema, breadcrumbs, ServiceSchema]
  };

  return (
    <>
      <SEOHead
        title="Premium Tiles & Sanitary Ware Products | Maa Saryu Agency Ayodhya | Best Prices"
        description="Premium tiles, granite, sanitary ware, CP fittings, bath accessories & kitchen fittings in Ayodhya. Wholesale & retail prices. Quality guaranteed. 15+ years experience."
        keywords={[
          "tiles products ayodhya",
          "sanitary ware products ayodhya",
          "granite products ayodhya",
          "bathroom fittings products",
          "ceramic tiles products",
          "porcelain tiles products", 
          "cp fittings products ayodhya",
          "bath accessories products",
          "kitchen fittings products",
          "marble tiles products",
          "wall tiles products",
          "floor tiles products",
          "construction materials ayodhya",
          "building materials ayodhya",
          "home improvement products ayodhya"
        ]}
        canonicalUrl="/products"
        ogTitle="Premium Tiles & Sanitary Ware Products - Best Prices in Ayodhya"
        ogDescription="🏗️ Premium tiles, granite & sanitary ware products in Ayodhya. Wholesale & retail prices. Quality guaranteed. 15+ years experience. Shop now!"
        structuredData={structuredData}
      />
      <Box sx={{ py: 4 }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 6, mt: 4 }}>
          <Typography variant="h2" component="h1" sx={{ 
            fontWeight: 'bold', 
            color: '#1a237e',
            mb: 2,
            fontSize: { xs: '2rem', md: '3rem' }
          }}>
            Our Products
          </Typography>
          <Typography variant="h6" sx={{ 
            color: '#666',
            maxWidth: '600px',
            mx: 'auto',
            lineHeight: 1.6
          }}>
            Discover our comprehensive range of digital solutions designed to help your business grow and succeed in the modern marketplace.
          </Typography>
        </Box>
        </Container>
        <Products />
      </Box>
    </>
  );
};

export default ProductsPage;
